import { ReactNode } from "react";
import { GreenTickGreenCircleGradient } from "components/icons/GreenTickGreenCircleGradient";
import Modal from "../Modal/Modal";
import { TriangleInfo } from "components/icons/TriangleInfo";
import { ExclamationFadedCircle } from "components/icons/ExclamationFadedCircle";

type StatusModalProps = {
  type: "success" | "warning" | "danger";
  title: string;
  showCloseButton?: boolean;
  children: ReactNode;
};

const statusIcon = {
  success: <GreenTickGreenCircleGradient />,
  warning: <TriangleInfo />,
  danger: <ExclamationFadedCircle />,
};

export const StatusModal = ({
  type,
  title,
  showCloseButton = true,
  children,
}: StatusModalProps) => (
  <div className="t-overflow-auto t-p-6 t-relative">
    {showCloseButton && (
      <div className="t-absolute t-top-4 t-right-4">
        <Modal.Close />
      </div>
    )}
    <div className="t-flex t-justify-between">{statusIcon[type]}</div>
    <p className="t-mb-2 t-text-subtext t-mt-5">{title}</p>
    <div className="t-text-body-sm t-text-text-30">{children}</div>
  </div>
);
